var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDone = function SvgDone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.274 11.78a.903.903 0 0 1 1.325 0l3.245 3.428L17.4 8.289a.903.903 0 0 1 1.325 0c.365.386.365 1.01 0 1.396L10.844 18l-4.57-4.824a1.025 1.025 0 0 1 0-1.396Z"
  })));
};
export default SvgDone;